var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Loader_svg__a)",
    d: "M61.3 32c1.767 0 3.217 1.436 3.04 3.195A31.999 31.999 0 1 1 29.305.16C31.064-.017 32.5 1.433 32.5 3.2c0 1.767-1.438 3.18-3.192 3.4A25.6 25.6 0 1 0 57.9 35.192C58.12 33.438 59.533 32 61.3 32Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Loader_svg__a",
    x1: 64.5,
    x2: 0.5,
    y1: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#885AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00193F"
  })))));
};
export default SvgLoader;